import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { fireWebhook, storeSsoSession } from '../api/apiService';

function SSOCallback() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const queryParameters = new URLSearchParams(location.search);
    const accessToken = queryParameters.get("accessToken");

    if (accessToken) {
      localStorage.setItem("x-device-access-token", accessToken);
      
      const deviceId = localStorage.getItem("x-device-service-id");
      const redirectUrl = localStorage.getItem("redirect");
      const storedWebhook = localStorage.getItem("webhook");
      const appName = localStorage.getItem("appName");
      const ssoRequestId = localStorage.getItem('sso_requestId');
      const ssoCodeChallenge = localStorage.getItem('sso_codeChallenge');

      const handleRedirect = async () => {
        if (ssoRequestId && ssoCodeChallenge) {
          try {
            await storeSsoSession({ requestId: ssoRequestId, accessToken, deviceId, codeChallenge: ssoCodeChallenge });
          } catch (e) {
            console.error('Failed to store SSO session:', e);
          } finally {
            localStorage.removeItem('sso_requestId');
            localStorage.removeItem('sso_codeChallenge');
          }
        }

        if (redirectUrl) {
          localStorage.removeItem("redirect");
          localStorage.removeItem("webhook");
          localStorage.removeItem("appId");
          localStorage.removeItem("appName");
          
          if (storedWebhook) {
            await fireWebhook(storedWebhook, accessToken, deviceId);
          }
          
          window.location.replace(`${redirectUrl}?accessToken=${accessToken}&xDeviceId=${deviceId}`);
        } else {
          let userId = 'user';
          try {
            const payload = JSON.parse(atob(accessToken.split('.')[1]));
            userId = payload.userId || 'user';
          } catch (e) {}
          navigate(`/${userId}/profile`, { replace: true, state: { ssoAuthSuccess: true, appName: appName } });
        }
      };

      handleRedirect();
    } else {
      navigate('/login', { replace: true });
    }
  }, [location, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center relative overflow-hidden">
      {/* Background Image Layer */}
      <div className="absolute inset-0 cyber-auth-bg" />
      {/* Dynamic Overlay */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-cyan-900/20 via-[#030305]/80 to-[#030305]/90" />
      
      <div className="relative z-10 flex flex-col items-center w-full max-w-md p-6 text-center">
        <div className="cyber-card p-8 border-green-500 shadow-[0_0_20px_rgba(0,255,0,0.2)] w-full">
          <div className="inline-flex items-center justify-center w-16 h-16 border border-green-500 bg-green-900/30 mb-6" style={{ clipPath: 'polygon(0 0, 100% 0, 100% calc(100% - 10px), calc(100% - 10px) 100%, 0 100%)' }}>
            <svg className="w-8 h-8 text-green-400 animate-pulse drop-shadow-[0_0_5px_rgba(0,255,0,0.8)]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="square" strokeLinejoin="miter" strokeWidth={2.5} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h2 className="text-xl font-black text-green-400 tracking-widest uppercase mb-3 drop-shadow-[0_0_8px_rgba(0,255,0,0.4)]">UPLINK_ESTABLISHED</h2>
          <p className="cyber-label text-[10px]">FINALIZING AUTHENTICATION... PLEASE STAND BY.</p>
        </div>
      </div>
    </div>
  );
}

export default SSOCallback;
